'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BoxCTA } from '@lichtblick/photon/atoms/box-cta/box-cta';
import { MagnifyingGlassXs } from '@lichtblick/photon/icons/objects/magnifying-glass-xs';
import { InfoXs } from '@lichtblick/photon/icons/symbols/info-xs';
import { Label } from '@lichtblick/photon/molecules/label/label';
import { useTracker } from '@lichtblick/tracker';
import { StatusMessage } from '@lichtblick/ui-components';
import classNames from 'classnames';
import { startTransition, useActionState, useCallback, useEffect, useState } from 'react';
import { submitForm } from './actions';
import styles from './soft-funnel-entry.module.scss';
import { Textfield } from './Textfield';
const message = `Leider kein Installationspartner in deiner Nähe gefunden. Werde benachrichtigt, sobald das SolarPaket \
in deiner Region verfügbar ist.`;
export const SoftFunnelEntryCard = ({ theme, title })=>{
    const [state, dispatch, pending] = useActionState(submitForm, {
        partnerAvailable: undefined,
        zipCode: ''
    });
    const measureAndSubmit = useCallback((formData)=>{
        window.optimizely?.push({
            type: 'event',
            eventName: 'solar-funnel-engagement'
        });
        startTransition(()=>dispatch(formData));
    }, [
        dispatch
    ]);
    const [currentZip, setCurrentZip] = useState('');
    const { trackCustomEvent } = useTracker();
    const isParkedLeadCase = state.partnerAvailable === false && currentZip === state.zipCode;
    useEffect(()=>{
        if (state.partnerAvailable) {
            location.assign(`/zuhause-checkout?buildingPostalCode=${state.zipCode}&page=HouseTypePage`);
        }
    }, [
        state
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: classNames(styles['stage-card'], styles[`theme-${theme}`]),
        children: /*#__PURE__*/ _jsxs("form", {
            action: measureAndSubmit,
            className: styles['funnel-form'],
            onSubmit: ()=>trackCustomEvent({
                    eventName: 'eaas_soft_funnel_cta'
                }),
            children: [
                /*#__PURE__*/ _jsx(Label, {
                    bold: true,
                    htmlFor: "zipCode",
                    renderAs: "label",
                    children: title || 'Wo soll Deine SolarAnlage installiert werden?'
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.controls,
                    children: [
                        /*#__PURE__*/ _jsx(Textfield, {
                            className: styles['text-field'],
                            defaultValue: state.zipCode,
                            forcedError: state.errorMessage,
                            leftSlot: /*#__PURE__*/ _jsx(MagnifyingGlassXs, {
                                className: styles['styled-search-icon']
                            }),
                            name: "zipCode",
                            onChange: ({ target })=>setCurrentZip(target.value),
                            pattern: "\\d{5}",
                            placeholder: "Postleitzahl eingeben",
                            required: true
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: styles['button-wrapper'],
                            children: isParkedLeadCase ? /*#__PURE__*/ _jsx(BoxCTA, {
                                as: "a",
                                href: `/zuhause-checkout?buildingPostalCode=${state.zipCode}&page=UnsupportedRegionPage`,
                                variant: "neutral-outline",
                                wide: true,
                                children: "Benachrichtigt mich"
                            }) : /*#__PURE__*/ _jsx(BoxCTA, {
                                as: "button",
                                loading: pending,
                                variant: "primary",
                                wide: true,
                                children: "SolarAnlage berechnen"
                            })
                        })
                    ]
                }),
                isParkedLeadCase && /*#__PURE__*/ _jsx(StatusMessage, {
                    icon: /*#__PURE__*/ _jsx(InfoXs, {}),
                    message: message,
                    status: "action",
                    type: "outline"
                })
            ]
        })
    });
};
export const SoftFunnelEntry = ({ paddingBottomDesktop, paddingBottomMobile, paddingTopDesktop, paddingTopMobile, theme, ...props })=>{
    return /*#__PURE__*/ _jsx("section", {
        className: classNames(styles.root, styles[`theme-${theme}`], styles['root-pbd-xl'], styles[`root-ptm-${paddingTopMobile || 'm'}`], styles[`root-pbm-${paddingBottomMobile || 'm'}`], styles[`root-ptd-${paddingTopDesktop || 'xl'}`], styles[`root-pbd-${paddingBottomDesktop || 'xl'}`], styles[`root-pbd-${paddingBottomDesktop || 'xl'}`]),
        children: /*#__PURE__*/ _jsx(SoftFunnelEntryCard, {
            ...props,
            theme: theme
        })
    });
};

//# sourceMappingURL=SoftFunnelEntry.js.map